
import { VBadge } from "vuetify/lib";

export default VBadge.extend({});
